import { render, staticRenderFns } from "./CalendarListItemLoadingPlaceholder.vue?vue&type=template&id=d84b1c90"
import script from "./CalendarListItemLoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./CalendarListItemLoadingPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports